module.exports = __webpack_public_path__ + "img/sld_tvm_dark.5dbc41f3.svg";